import { NgModule } from '@angular/core';
import { StrangularlibComponent } from './strangularlib.component';
import { TestAdderComponent } from './test-adder/test-adder.component';
import { TestSubtractComponent } from './test-subtract/test-subtract.component';



@NgModule({
  declarations: [StrangularlibComponent, TestAdderComponent, TestSubtractComponent],
  imports: [
  ],
  exports: [StrangularlibComponent, TestAdderComponent, TestSubtractComponent]
})
export class StrangularlibModule { }
